<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
    name: 'App',
    components: {},
    props: {},
    data() {
        return {};
    },
};
</script>

<style lang="scss">
// * {
//   box-sizing: border-box;
//   margin: 0;
//   padding: 0;
// }
#app {
  height: 100%;
}
body {
  height: 100vh;
}

#loading-container {
  display: grid;
  height: 100%;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
}

#spinner {
  grid-column: 2 / 2;
  grid-row: 2 / 2;
  align-self: center;
  justify-self: center;
}

.btn {
  border-radius: 0 !important;
  padding: 0.5rem 0.75rem !important;
}

.btn.btn-success,
.btn.btn-primary {
  background-color: #275D38;
  border-color: #275D38;
  margin-left: 4px;
}

.btn.btn-secondary {
  background-color: #F2CD00;
  border-color: #F2CD00;
  color: #000;
  margin-left: 4px;
}
.btn.btn-secondary:hover {
  background-color: #FFB600;
  border-color: #FFB600;
  color: #000;
}

@import "./assets/scss/styles.scss";
</style>
